import {slide as Menu} from 'react-burger-menu';
import {decorator as reduxBurgerMenu} from 'redux-burger-menu';

export default reduxBurgerMenu(Menu);


// WEBPACK FOOTER //
// ./app/core/components/menu.js